
module.exports = {
    data: {
        config: {},
        requireContexts: {
            templates: null,
            components: null,
            styles: null
        }
    },

    /**
     * this function returns the client config
     *
     * @returns {} - client app config
     */
    getConfig: function(){
        // deactivate debug stuff
        // TODO: NEW ENV
	    if(process.env.NODE_ENV === 'production'){
	        for(var key in this.data.config.debug){
	            if(key !== 'key') this.data.config.debug[key] = false;
            }
	    }

        return Object.freeze(this.data.config)
    },

    /**
     * this function is used to return the webpack-require-context variables
     *
     * @return  {} - require contexts
     */
    getRequireContexts: function(){
        return this.data.requireContexts;
    }
};